import type { BFFArticleBodyElement } from "@src/app/types/bff";
import cx from "classnames";

export default function ArticleInterview({
  element,
}: {
  element: BFFArticleBodyElement["interview"];
}) {
  return (
    <div className="mb-4">
      {element.children.map((item, index) => {
        return (
          <div key={index}>
            <div
              className={cx(
                "text-primary",
                item.type == "interview_question" ? "font-bold" : "font-normal",
                element.children[index + 1]?.type === "interview_question"
                  ? "mb-4"
                  : "",
              )}
            >
              {item.value}
            </div>
          </div>
        );
      })}
    </div>
  );
}
